var _mask, _g, _mask2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrasslandsProperty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9411_8304",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.776085 8.54852C0.979343 4.50175 1.08097 2.47837 2.38396 1.23919C3.68695 0 5.71288 0 9.76475 0H14.3443C18.3962 0 20.4221 0 21.7251 1.23919C23.0281 2.47837 23.1297 4.50176 23.333 8.54852L23.6343 14.5485C23.8571 18.9844 23.9685 21.2023 22.6382 22.6011C21.3078 24 19.0871 24 14.6457 24H9.46339C5.02196 24 2.80124 24 1.47088 22.6011C0.140521 21.2023 0.251921 18.9844 0.474721 14.5485L0.776085 8.54852Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9411_8304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2666 8.94238C53.9855 8.94238 72.3916 27.2747 72.3916 49.875C72.3916 72.4753 53.9855 90.8076 31.2666 90.8076C8.54774 90.8075 -9.8584 72.4752 -9.8584 49.875C-9.8584 27.2748 8.54774 8.94248 31.2666 8.94238Z",
    fill: "#85DFAE",
    stroke: "#15222F",
    strokeWidth: 2.88492
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.15723 8.94238C15.5617 8.94238 33.9678 27.2747 33.9678 49.875C33.9678 72.4753 15.5617 90.8076 -7.15723 90.8076C-29.8761 90.8075 -48.2822 72.4752 -48.2822 49.875C-48.2822 27.2748 -29.8761 8.94248 -7.15723 8.94238Z",
    fill: "#ACDF87",
    stroke: "#15222F",
    strokeWidth: 2.88492
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.7188 9.69238C2.00019 9.69238 20.4062 28.0247 20.4062 50.625C20.4062 73.2253 2.00019 91.5576 -20.7188 91.5576C-43.4376 91.5575 -61.8438 73.2252 -61.8438 50.625C-61.8438 28.0248 -43.4376 9.69248 -20.7188 9.69238Z",
    fill: "#43AF75",
    stroke: "#15222F",
    strokeWidth: 2.88492
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_9411_8304",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0275 6C6.0275 2.6865 8.72621 1.39462e-07 12.0548 4.29138e-07C15.3833 7.18813e-07 18.082 2.6865 18.082 6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14258 6L3.14258 8.88492L8.91242 8.88492L8.91242 6L6.0275 6L3.14258 6ZM15.1971 6L15.1971 8.88492L20.967 8.88492L20.967 6L18.082 6L15.1971 6ZM6.0275 6L8.91242 6C8.91242 4.29212 10.3072 2.88492 12.0548 2.88492L12.0548 4.29138e-07L12.0548 -2.88492C7.14526 -2.88492 3.14258 1.08088 3.14258 6L6.0275 6ZM12.0548 4.29138e-07L12.0548 2.88492C13.8024 2.88492 15.1971 4.29212 15.1971 6L18.082 6L20.967 6C20.967 1.08088 16.9643 -2.88492 12.0548 -2.88492L12.0548 4.29138e-07Z",
    fill: "white",
    mask: "url(#path-5-inside-1_9411_8304)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrasslandsProperty);
export default __webpack_public_path__ + "static/media/grasslands-property.89b28641.svg";
export { ForwardRef as ReactComponent };